import type { i18n } from 'i18next';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

export interface I18nProviderProps {
  i18n: i18n;
  children: ReactNode;
}

export function I18nProvider({ i18n, children }: I18nProviderProps) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
